/**
 * Mapeamento de logos de plataformas de checkout/pagamento
 * Logos armazenados em /public/assets/companies/
 */

export const PLATFORM_FAVICONS: Record<string, string> = {
  kiwify: '/assets/favicons/kiwifyf.png',
  braip: '/assets/favicons/braipf.png',
  eduzz: '/assets/favicons/eduzzf.png',
  monetizze: '/assets/favicons/monetizzef.png',
  perfectpay: '/assets/favicons/perfectpayf.png',
  perfect_pay: '/assets/favicons/perfectpayf.png',
  'perfect pay': '/assets/favicons/perfectpayf.png',
  guru: '/assets/favicons/guruf.png',
  ticto: '/assets/favicons/tictof.png',
  kirvano: '/assets/favicons/kirvanof.png',
  cartpanda: '/assets/favicons/cartpandaf.png',
  cart_panda: '/assets/favicons/cartpandaf.png',
  'cart panda': '/assets/favicons/cartpandaf.png',
  vegacheckout: '/assets/favicons/vegacheckoutf.png',
  vega_checkout: '/assets/favicons/vegacheckoutf.png',
  'vega checkout': '/assets/favicons/vegacheckoutf.png',
  cakto: '/assets/favicons/cakto.png',
  hotmart: '/assets/favicons/hotmartf.png',
};

export function getPlatformFavicon(platformName: string): string {
  const normalized = platformName.toLowerCase().trim().replace(/\s+/g, '_');
  return PLATFORM_FAVICONS[normalized] || PLATFORM_FAVICONS[platformName.toLowerCase().trim()] || '';
}

export const PLATFORM_LOGOS: Record<string, string> = {
  // Plataformas populares
  kiwify: '/assets/companies/kiwify-logo.svg',
  braip: '/assets/companies/logo-braip.svg',
  eduzz: '/assets/companies/eduzz.png',
  monetizze: '/assets/companies/monetizze-BLdBtItv.png',
  perfectpay: '/assets/companies/perfectPay-BKStvkgb.png',
  perfect_pay: '/assets/companies/perfectPay-BKStvkgb.png',
  guru: '/assets/companies/logo-guru-roxo.svg',
  digital_manager_guru: '/assets/companies/logo-guru-roxo.svg',
  ticto: '/assets/companies/ticto.svg',
  kirvano: '/assets/companies/kirvano-logo.svg',
  cartpanda: '/assets/companies/cartpanda-logo.svg',
  cart_panda: '/assets/companies/cartpanda-logo.svg',
  vegacheckout: '/assets/companies/vegaCheckout-bmUSrXpX.svg',
  vega_checkout: '/assets/companies/vegaCheckout-bmUSrXpX.svg',
  cakto: '/assets/companies/cakto.png',

  // Aliases comuns
  'perfect pay': '/assets/companies/perfectPay-BKStvkgb.png',
  'cart panda': '/assets/companies/cartpanda-logo.svg',
  'vega checkout': '/assets/companies/vegaCheckout-bmUSrXpX.svg',
};

/**
 * Retorna a URL do logo de uma plataforma
 * @param platformName Nome da plataforma (case-insensitive)
 * @param fallback URL de fallback caso a plataforma não seja encontrada
 */
export function getPlatformLogo(platformName: string, fallback?: string): string {
  const normalized = platformName.toLowerCase().trim().replace(/\s+/g, '_');
  return PLATFORM_LOGOS[normalized] || fallback || '';
}

/**
 * Lista de todas as plataformas disponíveis com seus logos
 */
export const AVAILABLE_PLATFORMS = [
  { id: 'kiwify', name: 'Kiwify', logo: PLATFORM_LOGOS.kiwify },
  { id: 'braip', name: 'Braip', logo: PLATFORM_LOGOS.braip },
  { id: 'eduzz', name: 'Eduzz', logo: PLATFORM_LOGOS.eduzz },
  { id: 'monetizze', name: 'Monetizze', logo: PLATFORM_LOGOS.monetizze },
  { id: 'perfectpay', name: 'Perfect Pay', logo: PLATFORM_LOGOS.perfectpay },
  { id: 'guru', name: 'Guru', logo: PLATFORM_LOGOS.guru },
  { id: 'ticto', name: 'Ticto', logo: PLATFORM_LOGOS.ticto },
  { id: 'kirvano', name: 'Kirvano', logo: PLATFORM_LOGOS.kirvano },
  { id: 'cartpanda', name: 'Cart Panda', logo: PLATFORM_LOGOS.cartpanda },
  { id: 'vegacheckout', name: 'Vega Checkout', logo: PLATFORM_LOGOS.vegacheckout },
  { id: 'cakto', name: 'Cakto', logo: PLATFORM_LOGOS.cakto },
] as const;
